import { Trans, useLingui } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/index';

interface TestConnectionButtonProps {
  onTestConnection: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}

export const TestConnectionButton = ({
  onTestConnection,
  isLoading,
  isDisabled,
}: TestConnectionButtonProps) => {
  const { t } = useLingui();

  return (
    <div className="vai-mt-4 vai-flex vai-justify-center">
      <Button
        onClick={onTestConnection}
        disabled={isDisabled}
        loading={isLoading}
      >
        {isLoading ? t`Testing connection` : t`Test Connection`}
      </Button>
    </div>
  );
};
